// extracted by mini-css-extract-plugin
module.exports = {"Accredited":"AccreditedText_Accredited__WMmGn","InfoBtn":"AccreditedText_InfoBtn__iI_Ri"};